import { memo, useCallback, useState } from 'react';

import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

import { useVideoCommentsQuery } from '@hooks';

import VideoComment from './VideoComment';
import VideoNewCommentInput from './VideoNewCommentInput';
import * as S from './styles';

type SortOrder = 'newest' | 'oldest';

type VideoCommentSectionProps = {
  videoId: number;
  commentsCount: number;
};

const VideoCommentSection = ({
  videoId,
  commentsCount,
}: VideoCommentSectionProps) => {
  const [sortOrder, setSortOrder] = useState<SortOrder>('newest');

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useVideoCommentsQuery(videoId, sortOrder);

  const allComments = data?.pages.flatMap((page) => page.data) ?? [];

  const toggleSort = useCallback(() => {
    setSortOrder((prev) => (prev === 'newest' ? 'oldest' : 'newest'));
  }, []);

  const SortIcon = sortOrder === 'newest' ? FiChevronDown : FiChevronUp;

  return (
    <S.Container>
      <S.Header>
        <S.HeaderTitle>
          Comentários
          <S.CountBadge>{commentsCount}</S.CountBadge>
        </S.HeaderTitle>
        <S.SortButton type="button" onClick={toggleSort}>
          {sortOrder === 'newest' ? 'Mais recentes' : 'Mais antigos'}
          <SortIcon />
        </S.SortButton>
      </S.Header>

      <VideoNewCommentInput videoId={videoId} sortOrder={sortOrder} />
      <S.InputDivider />

      {!!allComments.length && (
        <S.CommentList>
          {allComments.map((comment) => (
            <VideoComment
              key={comment.id}
              {...comment}
              videoId={videoId}
              sortOrder={sortOrder}
            />
          ))}
        </S.CommentList>
      )}

      {hasNextPage && (
        <S.LoadMoreButton
          type="button"
          onClick={() => fetchNextPage()}
          disabled={isFetchingNextPage}
        >
          {isFetchingNextPage ? 'Carregando...' : 'Ver mais comentários'}
          <FiChevronDown />
        </S.LoadMoreButton>
      )}
    </S.Container>
  );
};

export default memo(VideoCommentSection);
